const items = [
  { value: "+6", label: "anos na saúde" },
  { value: "Estomaterapia", label: "especialização" },
  { value: "Laserterapia", label: "recurso terapêutico" },
  { value: "Home Care", label: "no conforto da sua casa" },
];

export default function HeroStrip() {
  return (
    <section className="relative border-b border-background-200/40 bg-background-100/80 py-5 backdrop-blur-sm md:py-9">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
        {/* Mobile — compact editorial */}
        <div className="flex items-center justify-between gap-4 sm:hidden">
          <div className="flex items-baseline gap-2">
            <span className="font-heading text-3xl font-semibold tracking-tight text-foreground-950">
              +6
            </span>
            <span className="text-[11px] font-medium uppercase tracking-[0.16em] text-foreground-500">
              anos na saúde
            </span>
          </div>
          <div className="flex flex-col items-end gap-1">
            {items.slice(1).map((item) => (
              <span
                key={item.value}
                className="text-xs font-semibold tracking-wide text-foreground-700"
              >
                {item.value}
              </span>
            ))}
          </div>
        </div>

        {/* Desktop — horizontal with thin dividers */}
        <div className="hidden sm:flex sm:items-center sm:justify-between">
          {items.map((item, i) => (
            <div key={item.label} className="flex items-center sm:gap-0">
              {i > 0 && (
                <span className="hidden h-8 w-px bg-background-300/60 sm:block" />
              )}
              <div className="flex flex-col sm:items-start sm:px-6 lg:px-8">
                <span className="font-heading text-xl font-semibold tracking-tight text-foreground-950 md:text-2xl">
                  {item.value}
                </span>
                <span className="mt-0.5 text-[11px] font-medium uppercase tracking-[0.2em] text-foreground-500">
                  {item.label}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}